export const serverGetUserCodes = (url, type, field, cedule) => () => {
      let token = localStorage["auth"]
      let urlSend = `${url}?type=${type}&${field}=${cedule}&$limit=2000&$sort[createdAt]=-1`
      // console.log(urlSend)
      return fetch(urlSend, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
          // console.log('se obtiene ', r)
          if (r.error) {
            return Promise.reject(r.validation);
          }
          return r.data
      });
}


export const serverOTPValidate = (url, emited, serie, imei, cedule, amount, OTP, type,sequence) => () => {
  let token = localStorage["auth"]
  let urlSend = `${url}?emited=${emited}&serie=${serie}&imei=${imei}&number=${cedule}&amount=${amount}&otp=${OTP}&type=${type}&sequence=${sequence}`
  // console.log(urlSend)
  return fetch(urlSend, {
    method: 'GET',
    headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
  }).then(v => v.json())
  .then(r => {
      // console.log('se obtiene ', r)
      if (r.error) {
        return Promise.reject(r.validation);
      }
      return r
  });
}

export const serverOTPCompare = (url, serie, imei, cedule, OTP, request) => () => {
  let token = localStorage["auth"]
  let urlSend = `${url}?emited=USEROTP&serie=${serie}&otp=${OTP}&imei=${imei}&serie=${serie}&cedule=${cedule}&solicitante=${request}`
  // console.log(urlSend)
  return fetch(urlSend, {
    method: 'GET',
    headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
  }).then(v => v.json())
  .then(r => {
      // console.log('se obtiene ', r)
      if (r.error) {
        return Promise.reject(r.validation);
      }
      return r
  });
}


export const serverRefusePayment = (url, OTP, cedule, request, description) => () => {
  let token = localStorage["auth"]
  let urlSend = `${url}?emited=REJECT&otp=${OTP}&cedule=${cedule}&solicitante=${request}&description=${description}`
  // console.log(urlSend)
  return fetch(urlSend, {
    method: 'GET',
    headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
  }).then(v => v.json())
  .then(r => {
      // console.log('se obtiene ', r)
      if (r.error) {
        return Promise.reject(r.validation);
      }
      return r
  });
}

export const serverCancelPayment = (url, id, checked) => () => {
  let token = localStorage["auth"]
  let urlSend = `${url}/${id}`
  // console.log(urlSend)
  return fetch(urlSend, {
    method: 'PATCH',
    body: JSON.stringify({ checked }),
    headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
  }).then(v => v.json())
  .then(r => {
      // console.log('se obtiene ', r)
      if (r.error) {
        return Promise.reject(r.validation);
      }
      return r
  });
}

